export const getAuditFieldNameByKey = (key) => {
	const allNames = {
		maxQuantity: 'Max Quantity',
		minQuantity: 'Min Quantity',
		onHandQuantity: 'On Hand Quantity',
		transferred: 'Transferred',
		manual: 'Manual',
		purchase_order: 'Purchase Order',
		manual_count_adjustment: 'Manual count adjustment',
		manual_count_and_price_adjustment: 'Manual count and price adjustment',
		automated_zero_cost_adjustment: 'Automated zero cost adjustment',
		initial_min_quantity_adjustment: 'Inital min qty adjustment',
		min_quantity_adjustment: 'Min qty adjustment',
		max_quantity_adjustment: 'Max qty adjustment',
		shipped_to_work_order: 'Shipped to WO',
		returned_from_work_order: 'Returned from WO',
		receive: 'Received',
		[`return`]: 'Returned',
		invoice_price_adjustment: 'Invoice price adjustment',
		totalStockedPartsCost: 'Total stocked parts cost',
		received: 'Received',
		initial_disbursement: 'Initial Disbursement',
		disbursement: 'Disbursement',
		manual_price_adjustment: 'Manual price adjustment',
		burden_rate_change: 'Burden rate change',
	};
	return allNames[key] || key;
};
